export const PAGE_TYPE = {
  CATEGORY_LISTING: 'category_listing',
  BRAND_LISTING: 'brand_listing',
  SEARCH_LISTING: 'search_listing',
  OFFER_LISTING: 'offer_listing',
};

export const PRODUCT_CARD_DEFAULT = 'default';
export const PRODUCT_CARD_V2 = 'v2';
export const PRODUCT_CARD_V3 = 'v3';
export const PRODUCT_CARD_V4 = 'v4';
export const PRODUCT_CARD_CTA_REVAMP = 'cta_revamp';
export const TIPTILE_CLICKED = 'tiptile_clicked';
export const SITE_NAVIGATION = 'siteNavigation';
export const SITE_SUB_NAVIGATION = 'siteSubNavigation';
export const STORE_IN_STORE_URL = '/snsp';
export const PRO = 'pro';
export const DETAILS_API_ERROR_MESSAGE = 'Something went wrong. Try Again';
